import React from 'react';

const Lrn_us_mat_k6 = () => {
  return (
    <div>
      
    </div>
  );
}

export default Lrn_us_mat_k6;
